import API from "..";
import { API_CHANGE_PASSWORD } from "../../constants/api";

async function changePassword(data) {
  try {
    const response = await API.post(API_CHANGE_PASSWORD, data);
    return response.data;
  } catch (e) {
    throw e.response;
  }
}

export { changePassword };
